import { render, staticRenderFns } from "./ProveidorList.vue?vue&type=template&id=7715e6e2&scoped=true"
import script from "./ProveidorList.vue?vue&type=script&lang=js"
export * from "./ProveidorList.vue?vue&type=script&lang=js"
import style0 from "./ProveidorList.vue?vue&type=style&index=0&id=7715e6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7715e6e2",
  null
  
)

export default component.exports